import { post,get } from "./baseService";

export async function onGetArticles(code) {
    const response = await get(`article/${code}`, true);
    return response;
  }

  export async function getAllArticles(){
    const response =await get(`items`,true);
    return response
  }

  export async function getAllArticlesCategory(id){
    const response =await get(`countries/${id}/articles`,true);
    return response
  }


  
  export async function postCategoryIdByArticles(category){
    const response = await post(`items/getCategoryItems`,category, true);
    return response
  }


  export async function getArticle(code){
    const response = await get(`items/${code}`, true);
    return response
  }

